import i18n from "i18next";
import { initReactI18next } from 'react-i18next';

import en_US from "./en_US";
import it_IT from "./it_IT";

// wpApAdminSettings is a global variable defined in WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _wpApAdminSettings = {};
if (typeof variable !== 'wpApAdminSettings') {
    _wpApAdminSettings = window['wpApAdminSettings'];
}

const locale = _wpApAdminSettings && _wpApAdminSettings.wp_locale ?
    _wpApAdminSettings.wp_locale.split(",")[0].trim() : "en_US";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            "en_US": en_US,
            "it_IT": it_IT
        },
        lng: locale,
        fallbackLng: ["en_US"],

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }

    });

export default i18n;
